import React, { useEffect } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';

const Footer = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: false, offset: 20 });
  }, []);

  return (
    <footer className="bg-[#101828] py-8 px-6 md:px-8">
      <div className="container mx-auto flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
        <p className="text-[#98A2B3] text-sm text-center md:text-left" data-aos="fade-right" data-aos-delay="100">
          © 2026 e-save. All rights reserved.
        </p>
        <div className="flex items-center gap-2 text-[#98A2B3] text-sm" data-aos="fade-left" data-aos-delay="200">
          <i className="fas fa-satellite-dish text-[#29752B]"></i>
          <span>Our social channels are <span className="text-white font-medium">coming soon</span> — stay tuned!</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
